import React from 'react';
import './Skeleton.css';

export default function BlogPostSkeleton() {
    return (
        <div className="w-full max-w-[1700px] mx-auto py-6 space-y-6 skeleton-fade-in" aria-busy="true" aria-label="Loading translated article content">
            {/* Title Shimmer */}
            <div className="space-y-3">
                <div className="h-10 md:h-12 w-4/5 rounded-xl shimmer-pulse" />
                <div className="h-10 md:h-12 w-3/5 rounded-xl shimmer-pulse" />
            </div>

            {/* Excerpt Shimmer */}
            <div className="space-y-2 pt-2">
                <div className="h-5 w-11/12 rounded-lg shimmer-pulse opacity-80" />
                <div className="h-5 w-3/4 rounded-lg shimmer-pulse opacity-80" />
            </div>

            {/* Author & Meta Row */}
            <div className="flex items-center justify-between py-4 border-y border-slider">
                <div className="flex items-center gap-3">
                    <div className="w-11 h-11 rounded-full shimmer-pulse flex-shrink-0" />
                    <div className="space-y-2">
                        <div className="h-4 w-32 rounded shimmer-pulse" />
                        <div className="h-3 w-24 rounded shimmer-pulse opacity-70" />
                    </div>
                </div>
                <div className="flex items-center gap-2">
                    <div className="h-8 w-24 rounded-full shimmer-pulse" />
                    <div className="h-8 w-8 rounded-full shimmer-pulse" />
                </div>
            </div>

            {/* Cover Image Shimmer */}
            <div className="w-full aspect-[21/9] max-h-[500px] rounded-2xl shimmer-pulse" />

            {/* Content Body Paragraphs */}
            <div className="space-y-8 pt-4">
                {/* Paragraph 1 */}
                <div className="space-y-3">
                    <div className="h-4 w-full rounded shimmer-pulse" />
                    <div className="h-4 w-[98%] rounded shimmer-pulse" />
                    <div className="h-4 w-[95%] rounded shimmer-pulse" />
                    <div className="h-4 w-[75%] rounded shimmer-pulse" />
                </div>

                {/* Subheading Shimmer */}
                <div className="h-7 w-2/5 rounded-lg shimmer-pulse mt-6" />

                {/* Paragraph 2 */}
                <div className="space-y-3">
                    <div className="h-4 w-full rounded shimmer-pulse" />
                    <div className="h-4 w-[97%] rounded shimmer-pulse" />
                    <div className="h-4 w-[92%] rounded shimmer-pulse" />
                    <div className="h-4 w-[85%] rounded shimmer-pulse" />
                    <div className="h-4 w-[50%] rounded shimmer-pulse" />
                </div>

                {/* Quote Box Shimmer */}
                <div className="p-5 rounded-r-2xl border-l-4 border-primary-cyan bg-hover space-y-2.5">
                    <div className="h-4 w-11/12 rounded shimmer-pulse" />
                    <div className="h-4 w-3/4 rounded shimmer-pulse" />
                </div>

                {/* Paragraph 3 */}
                <div className="space-y-3">
                    <div className="h-4 w-full rounded shimmer-pulse" />
                    <div className="h-4 w-[96%] rounded shimmer-pulse" />
                    <div className="h-4 w-[94%] rounded shimmer-pulse" />
                    <div className="h-4 w-[60%] rounded shimmer-pulse" />
                </div>
            </div>
        </div>
    );
}
